module.exports = __webpack_public_path__ + "static/media/Antenas-Microondas.f86ebd58.jpeg";